import { t } from 'i18next';

export const SUSPICIOUS_SIGN_IN = 'Suspicious sign-in';
export const SUSPICIOUS_CREDENTIAL_ACCESS = 'Suspicious credential access';
export const SUSPICIOUS_USER_BEHAVIOR = 'Suspicious user behavior';
export const ADMIN_CONFIRMED_USER_COMPROMISED =
  'Admin confirmed user compromised';

export const atRiskUserCategoryTranslation = (category: string) => {
  return {
    [SUSPICIOUS_SIGN_IN]: t('riskUser.suspiciousSignIn'),
    [SUSPICIOUS_CREDENTIAL_ACCESS]: t('riskUser.suspiciousCredentialAccess'),
    [SUSPICIOUS_USER_BEHAVIOR]: t('riskUser.suspiciousUserBehavior'),
    [ADMIN_CONFIRMED_USER_COMPROMISED]: t(
      'riskUser.adminConfirmedUserCompromised'
    ),
  }[category];
};
